import { apiLocal, apiShc } from '@/services/Api'

function parse (objId, end) {
  return apiLocal().get(`parse/parsemj?proj=shc&objId=${objId}&end=${end}`)
}

function getSpoList (limit, skip, keys) {
  return apiShc().get(`classes/Reports`, {
    params: {
      where: {ringDataVer: {$exists: true}},
      order: '-createdAt',
      limit: limit || null,
      skip: skip || 0,
      keys: keys || 'objectId,ringDataVer,updatedAt,createdAt'
    }
  })
}

function getSpoListCounts () {
  return apiShc().get(`classes/Reports`, {
    params: {
      where: {ringDataVer: {$exists: true}},
      limit: 0,
      count: 1 // 获取总计数
    }
  })
}

function fetchByObjectId (objectId) {
  return apiShc().get(`classes/Reports/` + objectId, {
    params: {
      keys: 'objectId,ringDataVer,ringOriginalData,updatedAt,createdAt'
    }
  })
}

export {
  parse,
  getSpoList,
  getSpoListCounts,
  fetchByObjectId
}



// WEBPACK FOOTER //
// ./src/services/ShcService.js